// extracted by mini-css-extract-plugin
module.exports = {"firstSection":"GalleryComponents_firstSection__xtCMc","tooltipFileIcon":"GalleryComponents_tooltipFileIcon__goZjS"};